import { generateClasses } from '@formkit/themes'
import { genesisIcons } from '@formkit/icons'
import { fr } from '@formkit/i18n'
import { createMultiStepPlugin } from '@formkit/addons'
import { createProPlugin, autocomplete, transferlist, dropdown, taglist, datepicker } from '@formkit/pro'
import genesis from '~/themes/default'

const proPlugin = createProPlugin(import.meta.env.VITE_FORMKIT_PRO_KEY, {
  autocomplete,
  transferlist,
  dropdown,
  taglist,
  datepicker
})

export default {
  plugins: [proPlugin, createMultiStepPlugin()],
  icons: {
    ...genesisIcons
  },
  config: {
    classes: generateClasses(genesis)
  },
  locales: { fr },
  locale: 'fr'
}
